// this reduce function will handle how we update the state and send state parameters to components
import {
	FETCH_NODES,
	ENABLE_NODE,
	SET_LOADING,
	REMOVE_NODE,
	COLOR_PICKER,
	GET_COORDINATES,
	UPDATE_NAMES,
	SELECT_NODE,
	NODE_COLOR,
	UPDATE_LOG_SCALE_MIN_MAX,
	AVG_NODE_DATA,
} from "../types";

export default (state, action) => {
	switch (action.type) {
		case FETCH_NODES:
			return {
				...state,
				nodes: action.payload,
				loading: false,
			};
		case ENABLE_NODE:
			return {
				...state,
				nodesInUse: action.payload,
				loading: false,
			};
		case GET_COORDINATES:
			return {
				...state,
				coordinates: action.payload,
				loading: false,
			};
		case REMOVE_NODE:
			return {
				...state,
				nodesInUse: action.payload,
				loading: false,
			};

		case UPDATE_NAMES:
			return {
				...state,
				names: action.payload,
			};
		case COLOR_PICKER:
			return {
				...state,
				colorBy: action.payload,
			};
		case NODE_COLOR:
			return {
				...state,
				nodeColor: action.payload,
			};
		case UPDATE_LOG_SCALE_MIN_MAX:
			return {
				...state,
				log_scale_min_max: action.payload,
			};
		case SET_LOADING:
			return {
				...state,
				loading: true,
			};
		case SELECT_NODE:
			return {
				...state,
				currentNode: action.payload,
			};
		case AVG_NODE_DATA:
			return {
				...state,
				avgNodeData: action.payload,
			};
		default:
			return state;
	}
};
